import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useMutation } from "@apollo/client";
import useRoute from "../../router/useRoute";
import { LOGIN_WITH_ROUTE_TOKEN_MUTATION } from "./queries";
import { clearSessionData, setSessionLoginData } from "/imports/api/accounts/client/user-session";

import Debug from "debug";
const debug = Debug("token");

const TokenLogin = () => {
  const { goRoute, params } = useRoute();
  const { token } = params;

  const [loginWithRouteToken] = useMutation(LOGIN_WITH_ROUTE_TOKEN_MUTATION);

  useEffect(() => {
    loginWithRouteToken({
      variables: { token },
      fetchPolicy: "no-cache",
      skip: !token
    }).then(({ data, errors }) => {
      const error = errors?.[0];
      if (!error) {
        const { route, token: loginToken, user, userId, err } = data.loginWithRouteToken || {};
        if (err || !loginToken) {
          // in case a logined user click the url
          clearSessionData();
          debug("ERROR:", err);
          goRoute("signIn");
          toast.error("Invalid token!");
        } else {
          // login data
          setSessionLoginData({ token: loginToken, userId, user });

          goRoute(route.page, {
            _id: route._id,
            section: route.section
          });
        }
      } else {
        // in case a logined user click the url
        clearSessionData();
        goRoute("signIn");
        toast.error("Missing token!");
      }
    });
  }, [goRoute, loginWithRouteToken, token]);

  return <div>Please wait while we&apos;re logging you in....</div>;
};

export default TokenLogin;
